import { requireModule } from '../../../auth/guards';
import { MODULES } from '../../../auth/permissions';
import EmployeeDetailsPage from './pages/EmployeeDetails';
import EmployeesPage from './pages/Employees';

export const employeeRoutes = [
  {
    path: '/employees',
    loader: requireModule(MODULES.EMPLOYEES),
    element: <EmployeesPage />,
    children: [{ path: ':employeeId', element: <EmployeeDetailsPage /> }],
  },
];
